function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import path from 'ramda/src/path';
import { CHARGE_TIMING } from '../constants/wizard.constants';
export var GUIDServiceIdentifierValue = '[Other Services]';
export var ExistingItemsPlaceholderName = '[Other Existing Offers]';
export var ExistingServicesPlaceholderName = '[Other Existing Services]';
export var BILLER_RULE_INSTANCE_TYPE = {
  RECURRING: 0,
  USAGE: 1,
  ONE_TIME: 2,
  ENTITLEMENT: 3,
  CUSTOM: 4,
  EARLY_TERMINATION_FEE: 5,
  SUBSCRIPTION: 6,
  TRIGGER: 7,
  FINANCE: 8
};
export var PRODUCT_CLASSIFICATION = {
  PRODUCT: 1,
  SERVICE_FEATURE: 2,
  ADD_HOC: 3
};
export function getChargeAmount(chargeTiming) {
  var charges = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var result = path(['Amount'], charges.find(function (charge) {
    return charge.ChargeTiming === chargeTiming;
  }));
  return result || result === 0 ? result : '';
}
export function reorderFullCartItems(itemQuotes) {
  var products = [];
  var serviceFeatures = [];
  var addHoc = [];
  var otherItems = [];
  itemQuotes.forEach(function (itemQuote) {
    switch (itemQuote.productClassification) {
      case PRODUCT_CLASSIFICATION.PRODUCT:
        products.push(itemQuote);
        break;
      case PRODUCT_CLASSIFICATION.SERVICE_FEATURE:
        serviceFeatures.push(itemQuote);
        break;
      case PRODUCT_CLASSIFICATION.ADD_HOC:
        addHoc.push(itemQuote);
        break;
      default:
        otherItems.push(itemQuote);
    }
  });
  return [].concat(_toConsumableArray(reorderBasedOnBillerRuleType(products)), _toConsumableArray(reorderBasedOnBillerRuleType(serviceFeatures)), _toConsumableArray(reorderBasedOnBillerRuleType(addHoc)), _toConsumableArray(reorderBasedOnBillerRuleType(otherItems)));
}
function reorderBasedOnBillerRuleType(items) {
  var financedItems = [];
  var oneTimeItems = [];
  var recurringItems = [];
  var otherItems = [];
  items.forEach(function (item) {
    switch (item.type) {
      case BILLER_RULE_INSTANCE_TYPE.FINANCE:
        financedItems.push(item);
        break;
      case BILLER_RULE_INSTANCE_TYPE.ONE_TIME:
        oneTimeItems.push(item);
        break;
      case BILLER_RULE_INSTANCE_TYPE.RECURRING:
        recurringItems.push(item);
        break;
      default:
        otherItems.push(item);
    }
  });
  return [].concat(financedItems, oneTimeItems, recurringItems, otherItems);
}
export function getItemQuote(itemQuote, billerRuleConfigurations) {
  var _itemQuote$PricingPla, _itemQuote$PricingPla2;
  return {
    name: "".concat(itemQuote.Product.Name, ": ").concat(itemQuote.PricingPlan.Name),
    chargeQuotes: (itemQuote.ChargeQuotes || []).reduce(function (chargeQuotes, chargeQuote) {
      chargeQuotes.push({
        name: path(['Name'], billerRuleConfigurations[chargeQuote.BillerRuleInstanceType].find(function (brc) {
          return brc.Value === chargeQuote.BillerRuleConfigurationId;
        })),
        dueOnActivation: getChargeAmount(CHARGE_TIMING.DUE_ON_ACTIVATION, chargeQuote.ChargeQuoteTotals),
        dueOnFirstUse: getChargeAmount(CHARGE_TIMING.DUE_ON_FIRST_USE, chargeQuote.ChargeQuoteTotals),
        dueRecurring: getChargeAmount(CHARGE_TIMING.DUE_RECURRING, chargeQuote.ChargeQuoteTotals),
        dueToday: getChargeAmount(CHARGE_TIMING.DUE_TODAY, chargeQuote.ChargeQuoteTotals),
        dueNextInvoice: getChargeAmount(CHARGE_TIMING.BILL_CYCLE, chargeQuote.ChargeQuoteTotals),
        periodEndDate: chargeQuote.PeriodEndDate,
        periodStartDate: chargeQuote.PeriodStartDate,
        prorated: chargeQuote.Prorated
      });
      chargeQuote.DiscountItemQuotes && chargeQuote.DiscountItemQuotes.length && chargeQuote.DiscountItemQuotes.forEach(function (discountItemQuote) {
        chargeQuotes.push({
          name: discountItemQuote.DiscountName,
          isDiscount: true,
          dueOnActivation: getChargeAmount(CHARGE_TIMING.DUE_ON_ACTIVATION, discountItemQuote.DiscountQuoteTotals),
          dueOnFirstUse: getChargeAmount(CHARGE_TIMING.DUE_ON_FIRST_USE, discountItemQuote.DiscountQuoteTotals),
          dueRecurring: getChargeAmount(CHARGE_TIMING.DUE_RECURRING, discountItemQuote.DiscountQuoteTotals),
          dueToday: getChargeAmount(CHARGE_TIMING.DUE_TODAY, discountItemQuote.DiscountQuoteTotals),
          dueNextInvoice: getChargeAmount(CHARGE_TIMING.BILL_CYCLE, discountItemQuote.DiscountQuoteTotals),
          periodEndDate: discountItemQuote.PeriodEndDate,
          periodStartDate: discountItemQuote.PeriodStartDate,
          prorated: discountItemQuote.Prorated
        });
      });
      return chargeQuotes;
    }, []),
    depositQuotes: itemQuote.DepositQuotes,
    itemStatus: itemQuote.Action || undefined,
    productClassification: itemQuote.Product.ProductClassification,
    type: (_itemQuote$PricingPla = itemQuote.PricingPlan.BillerRuleInstanceThumbnails) === null || _itemQuote$PricingPla === void 0 ? void 0 : (_itemQuote$PricingPla2 = _itemQuote$PricingPla[0]) === null || _itemQuote$PricingPla2 === void 0 ? void 0 : _itemQuote$PricingPla2.Type
  };
}